import React from 'react';

import { PrismicRichText } from '@prismicio/react';
import { Spacer } from '@repo/ui/components/Spacer';

import ContentWrapper from 'components/Landing/ContentWrapper/ContentWrapper';
import SectionTitleAndText from 'components/Landing/SectionTitleAndText/SectionTitleAndText';
import SlideShowComponent from 'components/SlideShow/SlideShow';
import { getMediaCdnUrl } from 'global/prismicUtils';

const Slideshow = ({ slice }) => {
  return (
    <ContentWrapper
      background="white"
      className="slideshow"
      customWidth="1440px"
    >
      <SectionTitleAndText slice={slice} />
      {!!(slice.primary.title || slice.primary.text) && (
        <Spacer height="48px" />
      )}
      <SlideShowComponent
        duration={slice.primary.duration || 5000}
        slides={slice.items.map(({ image, video, text }) => ({
          image: getMediaCdnUrl(image.url),
          video: getMediaCdnUrl(video.url),
          text: <PrismicRichText field={text} />,
        }))}
      />
    </ContentWrapper>
  );
};

export default Slideshow;
